import { useState } from 'react';
import Dialog from './Dialog';
import { Text } from '../general/Text';
import { en } from '../../locales/en';
import { AsyncAction } from '../../types/general/asyncAction';
import { useGcsStore } from '../../store/useGcsStore';
import type { VehicleId } from '../../types/gcs/vehicle';
import type { MissionId } from '../../types/gcs/mission';
import { useLocalizedErrorMessage } from '../../hooks/useLocalizedErrorMessage';

interface ConfirmRerouteFromDockDialogProps {
  gcsId: string;
  vehicleId: VehicleId;
  missionId: MissionId;
  onClose: () => void;
}

function ConfirmRerouteFromDockDialog({ gcsId, missionId, onClose }: ConfirmRerouteFromDockDialogProps) {
  const getLocalizedErrorMessage = useLocalizedErrorMessage();
  const [rerouteFromDockAction, setRerouteFromDockAction] = useState<AsyncAction>(AsyncAction.initial());
  const rerouteHomeFromDock = useGcsStore((state) => state.rerouteHomeFromDock);

  const onConfirmClicked = async () => {
    try {
      setRerouteFromDockAction(AsyncAction.loading());
      await rerouteHomeFromDock(gcsId, missionId);
      setRerouteFromDockAction(AsyncAction.success(undefined));
      onClose();
    } catch (error) {
      setRerouteFromDockAction(AsyncAction.failure(error));
    }
  };

  return (
    <Dialog
      title={en.confirmRerouteHomeFromDockDialog.title}
      onClose={onClose}
      primaryButtonProps={{
        text: en.confirmRerouteHomeFromDockDialog.confirmButton,
        callback: onConfirmClicked,
        isLoading: rerouteFromDockAction.isLoading
      }}
      errorText={rerouteFromDockAction.isFailure ? getLocalizedErrorMessage(rerouteFromDockAction.error) : undefined}
    >
      <div style={{ width: 'var(--dialog-common-width)' }}>
        <Text variant='body1'>{en.confirmRerouteHomeFromDockDialog.body}</Text>
      </div>
    </Dialog>
  );
}

export default ConfirmRerouteFromDockDialog;
